import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { FileData } from '@/api/entities/engineCorrection';
import { AxiosResponse } from 'axios';

export const downloadFileSFTP = (fileName: string): Promise<AxiosResponse> => {
  return requestApi({
    url: `/files/download_v2?filename=${fileName}`,
    method: HTTP_METHOD.GET,
    responseType: 'blob',
  });
};

export const downloadVideo = () => {
  fetch('http://localhost:3000/files/download', {
    method: 'GET',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob(); // Récupère le fichier sous forme de Blob
    })
    .then((blob) => {
      // Crée un URL pour le Blob
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'video.mp4'); // Nom du fichier à télécharger
      document.body.appendChild(link);
      link.click(); // Simule un clic pour télécharger le fichier
      link.parentNode.removeChild(link); // Supprime le lien après le téléchargement
    })
    .catch((error) => {
      console.error('Error downloading the video:', error);
    });
};

export const deleteTrainingFiles = (
  fileName: string,
): Promise<AxiosResponse> => {
  return requestApi({
    url: '/files/delete-training',
    method: HTTP_METHOD.POST,
    body: { fileName },
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const uploadToSFTP = (fileData: FileData): Promise<AxiosResponse> => {
  const formData = new FormData();

  if (fileData.elementAnnotation) {
    formData.append('elementAnnotation', fileData.elementAnnotation);
  }

  if (fileData.dmgAnnotation) {
    formData.append('dmgAnnotation', fileData.dmgAnnotation);
  }

  if (fileData.image) {
    formData.append('image', fileData.image);
  }

  return requestApi({
    url: '/files/upload',
    method: HTTP_METHOD.POST,
    body: formData,
  });
};
